{
  "ru": {
    "passengerDataForm": {
      "resetFields": "Сбросить",
      "fare": {
        "label": "Выберите тариф",
        "adult": "Взрослый",
        "child": "Ребенок до 15 лет"
      },
      "lastName": "Фамилия",
      "firstName": "Имя",
      "patronymic": {
        "label": "Отчество",
        "without": "Без отчества"
      },
      "document": {
        "label": "Документ",
        "title": "Тип документа",
        "type": {
          "УЛ": "Удостоверение личности",
          "СР": "Свидетельство о рождении РК",
          "ПК": "Паспорт Казахстана",
          "ВЖ": "Вид на жительство",
          "ПН": "Паспорт РФ",
          "БГ": "Удостоверение личности без гражданства",
          "ЗЗ": "Другие иностр. документы",
          "ЗП": "Заграничный паспорт РФ",
          "ВБ": "Военный билет",
          "СУ": "Справка об утере удостоверения",
          "СО": "Справка об освобождении",
          "ПУ": "Паспорт Узбекистана",
          "default": "Номер документа"
        },
        "placeholder": {
          "УЛ": "000000000",
          "СР": "0000000",
          "ПК": "N00000000",
          "default": "000000000"
        }
      },
      "iin": {
        "label": "ИИН",
        "without": "Без ИИН"
      },
      "citizenship": "Гражданство",
      "gender": {
        "label": "Выберите пол",
        "male": "Мужчина",
        "female": "Женщина"
      },
      "dateOfBirth": {
        "label": "Дата рождения",
        "placeholder": "ДД.ММ.ГГГГ"
      }
    }
  },
  "kk": {
    "passengerDataForm": {
      "resetFields": "Жою",
      "fare": {
        "label": "Тарифті таңдаңыз",
        "adult": "Ересек",
        "child": "15 жасқа толмаған бала"
      },
      "lastName": "Тегі",
      "firstName": "Аты",
      "patronymic": {
        "label": "Әкесінің аты",
        "without": "Әкесінің атынсыз"
      },
      "document": {
        "label": "Құжат",
        "title": "Құжат түрі",
        "type": {
          "УЛ": "Жеке куәлік",
          "СР": "ҚР туу туралы куәлігі",
          "ПК": "Қазақстан паспорты",
          "ВЖ": "Қазақстанда тұру ыхтиярхаты",
          "ПН": "РФ паспорты",
          "БГ": "Азаматтығы жоқ адамның жеке куәлігі",
          "ЗЗ": "Басқа шетел құжаттары",
          "ЗП": "РФ шетел паспорты",
          "ВБ": "Әскери билет",
          "СУ": "Куәлік жоғалғаны туралы анықтама",
          "СО": "Босатылғаны туралы анықтама",
          "ПУ": "Өзбекстан паспорты",
          "default": "Құжат нөмірі"
        },
        "placeholder": {
          "УЛ": "000000000",
          "СР": "0000000",
          "ПК": "N00000000",
          "default": "000000000"
        }
      },
      "iin": {
        "label": "ЖСН",
        "without": "ЖСН-сыз"
      },
      "citizenship": "Азаматтығы",
      "gender": {
        "label": "Жынысын таңдаңыз",
        "male": "Еркек",
        "female": "Әйел"
      },
      "dateOfBirth": {
        "label": "Туған күні",
        "placeholder": "КК.АА.ЖЖЖЖ"
      }
    }
  },
  "en": {
    "passengerDataForm": {
      "resetFields": "Reset",
      "fare": {
        "label": "Select fare",
        "adult": "Adult",
        "child": "Child under 15"
      },
      "lastName": "Last name",
      "firstName": "First name",
      "patronymic": {
        "label": "Patronymic",
        "without": "Without patronymic"
      },
      "document": {
        "label": "Document",
        "title": "Document type",
        "type": {
          "УЛ": "Identity card",
          "СР": "Birth certificate",
          "ПК": "Kazakhstan passport",
          "ВЖ": "Residence permit",
          "ПН": "RF passport",
          "БГ": "Identity card without citizenship",
          "ЗЗ": "Other foreign documents",
          "ЗП": "RF foreign passport",
          "ВБ": "Military ID",
          "СУ": "Certificate of loss of ID",
          "СО": "Certificate of release",
          "ПУ": "Uzbekistan passport",
          "default": "Document number"
        },
        "placeholder": {
          "УЛ": "000000000",
          "СР": "0000000",
          "ПК": "N00000000",
          "default": "000000000"
        }
      },
      "iin": {
        "label": "IIN",
        "without": "Without IIN"
      },
      "citizenship": "Citizenship",
      "gender": {
        "label": "Select gender",
        "male": "Male",
        "female": "Female"
      },
      "dateOfBirth": {
        "label": "Date of birth",
        "placeholder": "DD.MM.YYYY"
      }
    }
  }
}
